import { LANDMARK_IDS, NPC_IDS, type LandmarkId, type NpcId } from "./catalog";

export type { LandmarkId, NpcId };

export type SaveState = {
  postcards: LandmarkId[];
  badges: NpcId[];
  muted: boolean;
};

const KEY = "aihy-planet-v2";

const empty = (): SaveState => ({ postcards: [], badges: [], muted: false });

/** 只保留当前地图上还存在的 id，旧存档里被下线的小屋不再计数 */
function known<T extends string>(raw: unknown, ids: readonly T[]): T[] {
  if (!Array.isArray(raw)) return [];
  const out: T[] = [];
  for (const v of raw) {
    if (typeof v === "string" && (ids as readonly string[]).includes(v) && !out.includes(v as T)) out.push(v as T);
  }
  return out;
}

export function loadSave(): SaveState {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return empty();
    const parsed = JSON.parse(raw) as Partial<SaveState>;
    return {
      postcards: known(parsed.postcards, LANDMARK_IDS),
      badges: known(parsed.badges, NPC_IDS),
      muted: Boolean(parsed.muted),
    };
  } catch {
    return empty();
  }
}

function persist(save: SaveState): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(save));
  } catch {
    /* 隐私模式或配额满：本次不落盘 */
  }
}

export function unlockPostcard(save: SaveState, id: LandmarkId): boolean {
  if (save.postcards.includes(id)) return false;
  save.postcards.push(id);
  persist(save);
  return true;
}

export function unlockBadge(save: SaveState, id: NpcId): boolean {
  if (save.badges.includes(id)) return false;
  save.badges.push(id);
  persist(save);
  return true;
}

export function setMuted(save: SaveState, muted: boolean): void {
  save.muted = muted;
  persist(save);
}
